import { Component } from '@angular/core';
import { PageHeaderComponent } from '@core/components/page-header/page-header.component';

@Component({
  selector: 'app-settings-page',
  imports: [PageHeaderComponent],
  templateUrl: './settings-page.html',
})
export class SettingsPage {}
